<script setup lang="ts">
import type { ContentFile } from "~/models/Content/schemas/media.schema"

defineProps<{
  files: ContentFile[]
}>()
</script>

<template>
  <section class="flex flex-wrap gap-3">
    <h2 class="sr-only">
      Vedlagte filer
    </h2>
    <UArticleFileDownload
      v-for="file in files"
      :key="file.binaryFile.id"
      :file="file"
    />
  </section>
</template>
